import { render } from "./CampaignModeration.vue?vue&type=template&id=58502a12"
import script from "./CampaignModeration.vue?vue&type=script&lang=js"
export * from "./CampaignModeration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__